import { View, Text } from "@react-pdf/renderer";
import { IAbnNotice } from "types/AbnNotice/AbnNotice";

import { styles } from "../styles";

export function PatientSection({
  name,
  dateOfBirth,
  procedureCodes,
  activeAbnNotice,
}: {
  name: string;
  dateOfBirth: string;
  procedureCodes?: string[] | null;
  activeAbnNotice?: IAbnNotice | null;
}) {
  return (
    <View
      style={{ display: "flex", flexDirection: "column", marginTop: 0, gap: 4 }}
    >
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
          gap: "10px",
        }}
      >
        <View
          style={{
            width: "50%",
            flexDirection: "row",
            alignItems: "flex-end",
            gap: 4,
          }}
        >
          <Text
            style={{
              ...styles.bodyText,
              fontFamily: "Helvetica-Bold",
              marginBottom: 0,
            }}
          >
            Patient Name:
          </Text>
          <View
            style={{
              flexGrow: 1,
              borderBottom: "1px solid black",
              paddingBottom: 2,
            }}
          >
            <Text style={{ fontFamily: "Helvetica" }}>{name}</Text>
          </View>
        </View>
        <View
          style={{
            width: "50%",
            flexDirection: "row",
            alignItems: "flex-end",
            gap: 4,
          }}
        >
          <Text
            style={{
              ...styles.bodyText,
              fontFamily: "Helvetica-Bold",
              marginBottom: 0,
            }}
          >
            Date of Birth:
          </Text>
          <View
            style={{
              flexGrow: 1,
              borderBottom: "1px solid black",
              paddingBottom: 2,
            }}
          >
            <Text style={{ fontFamily: "Helvetica" }}>{dateOfBirth}</Text>
          </View>
        </View>
      </View>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "flex-end",
          gap: 4,
        }}
      >
        <Text
          style={{
            ...styles.bodyText,
            fontFamily: "Helvetica-Bold",
            marginBottom: 0,
          }}
        >
          Item or Service:
        </Text>
        <View
          style={{
            flexGrow: 1,
            borderBottom: "1px solid black",
            paddingBottom: 2,
          }}
        >
          <Text style={{ fontFamily: "Helvetica" }}>
            CPT CODES: {procedureCodes?.join(", ")}
          </Text>
        </View>
      </View>
      <View
        style={{
          width: "100%",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 4,
        }}
      >
        <Text
          style={{
            ...styles.bodyText,
            fontFamily: "Helvetica-Bold",
            marginBottom: 0,
          }}
        >
          Reason for this service or item may not be covered:
        </Text>
        <View
          style={{
            flexGrow: 1,
            borderBottom: "1px solid black",
            paddingBottom: 2,
            width: "100%",
          }}
        >
          <Text style={{ fontFamily: "Helvetica" }}>
            {activeAbnNotice?.documentSnapshot?.reason ||
              `Your insurance does not consider the procedure(s) listed above medically necessary for your condition or deems them experimental.`}
          </Text>
        </View>
      </View>
    </View>
  );
}
